import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../constants/config';
import { createBaseQuery } from './baseQuery';

export interface BusinessSystem {
  id: string;
  name: string;
  organizationCount: number;
}

export interface BusinessSystemDetail {
  id: string;
  name: string;
  organizations: {
    id: string;
    organizationId: string;
    name: string;
    businessSystemId?: string;
    businessSystemName?: string;
    created: string;
    modified: string;
  }[];
}

export const businessSystemsApi = createApi({
  reducerPath: 'businessSystemsApi',
  baseQuery: createBaseQuery(`${config.apiUrl}/api`),
  tagTypes: ['BusinessSystem'],
  endpoints: (builder) => ({
    getBusinessSystems: builder.query<BusinessSystem[], void>({
      query: () => '/businesssystems',
      providesTags: ['BusinessSystem'],
    }),
    
    getBusinessSystemById: builder.query<BusinessSystemDetail, string>({
      query: (id) => `/businesssystems/${id}`,
      providesTags: (result, error, id) => [{ type: 'BusinessSystem', id }],
    }),
    
    getBusinessSystemByName: builder.query<BusinessSystemDetail, string>({
      query: (name) => `/businesssystems/by-name/${name}`,
      providesTags: (result, error, name) => [{ type: 'BusinessSystem', id: name }],
    }),
    
    getBusinessSystemOrganizations: builder.query<BusinessSystemDetail['organizations'], string>({
      query: (id) => `/businesssystems/${id}/organizations`,
      providesTags: (result, error, id) => [{ type: 'BusinessSystem', id }],
    }),
  }),
});

export const {
  useGetBusinessSystemsQuery,
  useGetBusinessSystemByIdQuery,
  useGetBusinessSystemByNameQuery,
  useGetBusinessSystemOrganizationsQuery,
} = businessSystemsApi;